import { Box, Center, Text } from '@mantine/core';
import type { ReactNode } from 'react';
import { barve } from '../tema';
import { IME_APLIKACIJE } from '../ime';
import { Logotip } from './Logotip';

/**
 * Temno ozadje s prelivom in logotipom za vstopne zaslone (prijava, zamenjava gesla, registracija) – kot PrijavaTab.
 * {@code sirina} je največja širina vsebine (obrazec registracije je širši od prijave).
 */
export function TemnoOzadje({ children, sirina = 400 }: { children: ReactNode; sirina?: number }) {
  return (
    <Box
      mih="100vh"
      style={{ background: `linear-gradient(180deg, ${barve.ozadje} 0%, ${barve.ozadjeTemno} 100%)` }}
      p="md"
    >
      <Center mih="calc(100vh - 80px)" style={{ flexDirection: 'column', gap: 36 }}>
        <Logotip podnaslov="Poslovanje z vozili" />
        <Box w="100%" maw={sirina}>
          {children}
        </Box>
      </Center>
      <Text size="xs" style={{ color: barve.besediloNaOzadjuSekundarno }}>
        {IME_APLIKACIJE} · LunaLabs
      </Text>
    </Box>
  );
}
